import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import TopNavbarBack from "../../components/TopNavbarBack";
import Navbar from "../../components/Navbar";
import { toFarsiNumber } from "../../custom/helpers";
import { useGroupApi, relativeTime } from "./groupApi";
import { GroupAvatar } from "./components/ui";
import CreateGroupSheet from "./components/CreateGroupSheet";
import "../../styles/Fonts.css";
import "../../styles/Buttons.css";
import "../../styles/Groups.css";

export default function Groups() {
  const { call } = useGroupApi();
  const navigate = useNavigate();
  const [groups, setGroups] = useState(null); // null = loading
  const [error, setError] = useState(false);
  const [creating, setCreating] = useState(false);

  const load = () => {
    setError(false);
    call("groups", { method: "GET" })
      .then((r) => {
        // a single group opens directly; the list is only for 2+ groups
        if (r.groups.length === 1) navigate(`/groups/${r.groups[0].group_id}`, { replace: true });
        else setGroups(r.groups);
      })
      .catch(() => { setError(true); setGroups([]); });
  };
  useEffect(load, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="grpPage yekan">
      <TopNavbarBack
        title="گروه‌ها"
        rbuttonIcon={["icon-iconchevron-right"]}
        rbackground={["rectangle1"]}
        lbuttonIcon={["icon-iconplus"]}
        lbackground={["rectangle1"]}
        lfunction={() => setCreating(true)}
      />
      <div className="grpWrap">
        <div className="grey-2 yekan" style={{ marginBottom: 12 }}>با دوستان و خانواده با هم برنامه غذایی بچینین</div>

        {groups === null && (
          <div className="grpList">
            {[0, 1, 2].map((i) => <div key={i} className="grpSkeleton" />)}
          </div>
        )}

        {error && (
          <div className="grpNotice">
            بارگذاری گروه‌ها ممکن نشد.{" "}
            <button type="button" className="grpBtn grpBtn-sm" onClick={load}>تلاش دوباره</button>
          </div>
        )}

        {groups && groups.length === 0 && !error && (
          <div className="grpEmpty">
            <span className="grpEmptyIcon">👨‍👩‍👧</span>
            <div className="grpEmptyTitle yekan">اولین گروهت رو بساز و با هم غذا برنامه‌ریزی کنین</div>
            <button type="button" className="grpBtn" style={{ marginTop: 12 }} onClick={() => setCreating(true)}>ساخت گروه</button>
          </div>
        )}

        {groups && groups.length > 0 && (
          <div className="grpList">
            {groups.map((g) => (
              <Link key={g.group_id} to={`/groups/${g.group_id}`} className="grpCard">
                <GroupAvatar name={g.name} image={g.image_path} size="lg" />
                <div className="grpCardBody">
                  <div className="grpCardTop">
                    <span className="grpCardName yekan">{g.name}</span>
                    <span className="grpCardMeta yekan">{relativeTime(g.last_activity)}</span>
                  </div>
                  <div className="grpCardMeta yekan">{toFarsiNumber(g.member_count)} عضو{g.role === "owner" ? " · مدیر" : ""}</div>
                  <div className="grpCardPreview yekan">
                    {g.last_message ? `${g.last_sender}: ${g.last_message}` : "هنوز پیامی نیست"}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>

      {creating && <CreateGroupSheet onClose={() => setCreating(false)} />}
      <Navbar />
    </div>
  );
}
